var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger",on:{"click":_vm.toggleClick}},[(!_vm.isActive)?_c('img',{attrs:{"src":require("@/assets/spread.svg")}}):_c('img',{attrs:{"src":require("@/assets/fold.svg"),"icon-class":"fold"}})])}
var staticRenderFns = []

export { render, staticRenderFns }